import { useState } from "react";

import useDidMountEffect from "./useDidMountEffect";

type RequestStatus = "loading" | "success" | "error";

type Args = {
  lastAction: string;
  successAction: string;
  failureAction: string;
};

const useRequestStatus = ({
  lastAction,
  successAction,
  failureAction,
}: Args) => {
  const [status, setStatus] = useState<RequestStatus>("loading");

  useDidMountEffect(() => {
    if (lastAction === successAction) {
      setStatus("success");
    } else if (lastAction === failureAction) {
      setStatus("error");
    }
  }, [lastAction, successAction, failureAction]);

  return status;
};

export default useRequestStatus;
